<filter-view-layout
	*ngIf="(currentView$ | async) as currentView">
	<div filter-view-filter-bar>
		<div [formGroup]="form">
			<div class="filter-container">
				<mat-form-field goSelect>
					<mat-label>{{ 'common_filter-by' | translate }}</mat-label>
					<mat-select
						formControlName="filterBy"
						disableOptionCentering
						data-cy="archive-filter-menu"
						panelClass="offsetPanel">
						<mat-option
							[attr.data-cy]="'archive-filter-' + option"
							*ngFor="let option of filterOptions$ | async"
							[value]="option">
							{{ archiveFilterTranslations[option] | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="sort-container">
				<mat-form-field goSelect>
					<mat-label>{{ 'common_sort-by' | translate }}</mat-label>
					<mat-select
						formControlName="sortBy"
						disableOptionCentering
						panelClass="offsetPanel">
						<mat-option
							*ngFor="let option of sortByOptions"
							[value]="option">
							{{ sortOrderTranslations[option] | translate }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div filter-view-options-bar>
		<button *ngIf="!UADetect.isMobile() && currentView === views.LIST"
			type="button"
			class="icon-btn view-switcher ficon-app-grid"
			[matTooltip]="'change-to-grid-view' | translate"
			matTooltipPosition="left"
			(click)="viewStateDataSource.toggleCurrentView()"></button>
		<button *ngIf="!UADetect.isMobile() && currentView === views.GRID"
			type="button"
			class="icon-btn view-switcher ficon-app-list"
			[matTooltip]="'change-to-list-view' | translate"
			matTooltipPosition="left"
			(click)="viewStateDataSource.toggleCurrentView()"></button>
	</div>
	<div filter-view-content>
		<ng-container *ngIf="(archivedListDataSource.connect() | async)?.length && (archivedListDataSource.loading$ | async) ===  false; else zeroState">
			<div class="grid-view" *ngIf="currentView === views.GRID">
				<archive-grid-view></archive-grid-view>
			</div>

			<div class="list-view" *ngIf="currentView === views.LIST">
				<archive-table-view></archive-table-view>
			</div>
		</ng-container>

		<ng-template #zeroState>
			<archive-zero-state></archive-zero-state>
		</ng-template>
	</div>
	<div filter-view-content-loading-bar>
		<div class="loading-bar-spinner"
			*ngIf="archivedListDataSource.isLoadingMoreItems$ | async"
		>
			<span class="ficon-spinner ficon-spin"></span>
		</div>
	</div>
</filter-view-layout>
